import React from 'react';
import { FaCogs, FaRocket, FaShieldAlt, FaUsers } from 'react-icons/fa';
import { motion } from 'framer-motion';
import './AutomationDevelopment.css';

const services = [
  {
    title: 'Custom Automation Solutions',
    icon: <FaCogs />,
    description: 'Tailored automation workflows to streamline your business operations.',
  },
  {
    title: 'AI-Powered Integrations',
    icon: <FaRocket />,
    description: 'Seamless integration of AI technologies to enhance decision-making processes.',
  },
  {
    title: 'Robust Security Protocols',
    icon: <FaShieldAlt />,
    description: 'Implementing top-notch security measures to protect your automated systems.',
  },
  {
    title: '24/7 Support & Maintenance',
    icon: <FaUsers />,
    description: 'Comprehensive support and maintenance services to ensure smooth operations.',
  },
];

const AutomationDevelopment = () => {
  return (
    <div className="automation-page">
      {/* Hero Section */}
      <section className="hero">
        <div className="hero-overlay" />
        <div className="hero-content">
          <motion.h1
            initial={{ opacity: 0 }}
            animate={{ opacity: 1 }}
            transition={{ duration: 1 }}
          >
            Empower Your Business with Advanced Automation Solutions
          </motion.h1>
          <motion.p
            initial={{ opacity: 0 }}
            animate={{ opacity: 1 }}
            transition={{ duration: 1, delay: 0.2 }}
          >
            Streamline operations, enhance efficiency, and drive growth with our tailored automation services.
          </motion.p>
          <motion.button
            className="cta-btn"
            whileHover={{ scale: 1.05, boxShadow: '0 0 15px rgba(0,0,0,0.3)' }}
          >
            Get Started
          </motion.button>
        </div>
      </section>

      {/* Services Section */}
      <section className="services">
        <h2>Our Expertise</h2>
        <div className="service-cards">
          {services.map((service, index) => (
            <motion.div
              key={index}
              className="service-card"
              whileHover={{ scale: 1.05 }}
              initial={{ opacity: 0 }}
              animate={{ opacity: 1 }}
              transition={{ delay: index * 0.2 }}
            >
              <div className="service-icon">{service.icon}</div>
              <h3>{service.title}</h3>
              <p>{service.description}</p>
            </motion.div>
          ))}
        </div>
      </section>

      {/* CTA Section */}
      <section className="cta">
        <h2>Ready to Automate?</h2>
        <p>Contact us today to discuss how we can help you achieve seamless automation.</p>
        <motion.button
          className="cta-btn"
          whileHover={{ scale: 1.05, boxShadow: '0 0 15px rgba(0,0,0,0.3)' }}
        >
          Schedule a Consultation
        </motion.button>
      </section>
    </div>
  );
};

export default AutomationDevelopment;
